class SaleCountdown {
  constructor(element) {
    this.element = element;
    this.timerId = undefined;
    this.valueEls = {
      days: element.querySelector('[data-unit="days"] .sale-countdown__value'),
      hours: element.querySelector('[data-unit="hours"] .sale-countdown__value'),
      minutes: element.querySelector('[data-unit="minutes"] .sale-countdown__value'),
      seconds: element.querySelector('[data-unit="seconds"] .sale-countdown__value'),
    };
    this.endTimestamp = this.getTimestamp(element.dataset.endDate, element.dataset.endTime || '23:59');
    this.startTimestamp = element.dataset.startDate
      ? this.getTimestamp(element.dataset.startDate, element.dataset.startTime || '00:00')
      : null;
    this.alwaysShow = element.dataset.alwaysShow === 'true';
    this.isOnSale = this.alwaysShow || !element.classList.contains('hidden');

    if (!this.endTimestamp || Object.values(this.valueEls).some((el) => !el)) {
      element.classList.add('hidden');
      return;
    }

    this.tick();
    this.start();
  }

  start() {
    if (this.timerId) return;
    this.timerId = window.setInterval(() => this.tick(), 1000);
  }

  stop() {
    if (!this.timerId) return;
    window.clearInterval(this.timerId);
    this.timerId = undefined;
  }

  destroy() {
    this.stop();
    saleCountdownInstances.delete(this.element);
  }

  getTimestamp(date, time) {
    const timeZone = this.element.dataset.timezone;
    if (!date || !timeZone) return null;
    return storeLocalToUtc(date, time, timeZone);
  }

  isInWindow() {
    const now = Date.now();
    if (this.startTimestamp && now < this.startTimestamp) return false;
    if (!this.endTimestamp || now >= this.endTimestamp) return false;
    return true;
  }

  updateVisibility() {
    const shouldShow = (this.alwaysShow || this.isOnSale) && this.isInWindow();
    this.element.classList.toggle('hidden', !shouldShow);
  }

  setOnSale(onSale) {
    this.isOnSale = onSale;
    this.updateVisibility();
  }

  tick() {
    const now = Date.now();

    if (!this.endTimestamp || now >= this.endTimestamp) {
      this.element.classList.add('hidden');
      this.stop();
      return;
    }

    const remaining = Math.max(0, this.endTimestamp - now);
    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.valueEls.days.textContent = String(days);
    this.valueEls.hours.textContent = String(hours).padStart(2, '0');
    this.valueEls.minutes.textContent = String(minutes).padStart(2, '0');
    this.valueEls.seconds.textContent = String(seconds).padStart(2, '0');

    this.updateVisibility();
  }
}

const saleCountdownInstances = new WeakMap();

function initSaleCountdowns(root = document) {
  root.querySelectorAll('.sale-countdown').forEach((element) => {
    const existing = saleCountdownInstances.get(element);
    if (existing) existing.destroy();
    saleCountdownInstances.set(element, new SaleCountdown(element));
  });
}

function bootSaleCountdowns() {
  initSaleCountdowns();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootSaleCountdowns);
} else {
  bootSaleCountdowns();
}

document.addEventListener('product-info:loaded', (event) => {
  initSaleCountdowns(event.target);
});

document.addEventListener('shopify:section:load', (event) => {
  initSaleCountdowns(event.target);
});

if (typeof subscribe === 'function') {
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const sectionId = event.data?.sectionId;
    const variant = event.data?.variant;
    if (!sectionId || !variant) return;

    const onSale = Boolean(variant.compare_at_price && variant.price < variant.compare_at_price);
    document.querySelectorAll(`.sale-countdown[data-section-id="${sectionId}"]`).forEach((element) => {
      const instance = saleCountdownInstances.get(element);
      if (instance) instance.setOnSale(onSale);
    });
  });
}
